import { render, staticRenderFns } from "./nationalset.vue?vue&type=template&id=c2db6aac&scoped=true&"
import script from "./nationalset.vue?vue&type=script&lang=js&"
export * from "./nationalset.vue?vue&type=script&lang=js&"
import style0 from "./nationalset.vue?vue&type=style&index=0&id=c2db6aac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2db6aac",
  null
  
)

export default component.exports